module.exports = {"data":{"site":{"siteMetadata":{"title":"Jorge Mancheno, Product Designer","siteUrl":"https://jorgemancheno.com","email":"hello@jorgemancheno.com","dribbbleUrl":"https://dribbble.com/jorgemancheno","githubUrl":"https://github.com/jorgemancheno","twitterUrl":"https://twitter.com/jorgemancheno"}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/contact.json
// module id = 380
// module chunks = 184662623972074